import _ from "lodash";
import cn from "classnames";
import { yTopFull } from "hyam-core/animation/defaults";

export const styles = {
  container: cn(
    "hyam-layout relative",
    "fixed top-0 z-40",
    "flex",
    "items-center",
    "transition-colors duration-1000",
  ),
  background: cn(
    " bg-white absolute left-0 ml-[50%] -translate-x-1/2 -z-10 border-b-[1px] border-hyam-grey/30",
    "h-full w-screen block transition duration-200",
  ),
  container_color_primary: cn(),
  // "bg-hyam-primary-600 xl:bg-hyam-primary-600",
  container_scroll_top: "",

  logo_container: cn(
    // NOTE: setting the height of the whole nav bar on the logo container
    "transition duration-500",
    "relative h-hyam-navbar-h-sm xl:h-hyam-navbar-h-xl ml-[50%] -translate-x-1/2",
    "flex items-center",
    "w-fit px-6",
  ),
  logo: "h-5 xl:h-6 ",
  hamburger: cn(
    "transition duration-500",
    // "ml-4 md:ml-0",
  ),

  menu_container: cn(
    "block absolute",
    "h-full",
    "flex",
    "justify-center items-center",
    "gap-2",
    "cursor-pointer",
  ),

  menu_label: cn(
    "hidden xl:block",
    "uppercase",
    "hyam-text-small",
    "mb-0",
  ),

  link: cn(
    "hyam-text-small mb-0 pointer-events-auto uppercase",
    "decoration-transparent hover:decoration-hyam-black",
    "underline underline-offset-4 decoration-2",
    "transition duration-200 hyam-animate-text",
  ),

  link_active:
    "underline underline-offset-4 decoration-2 decoration-hyam-black font-medium",

  buttons_container: cn(
    "hidden xl:flex",
    "flex grow justify-end",
    "gap-8 md:gap-4 xl:gap-6",
    "items-center",
  ),

  button: "mb-0",
};

export type HyamPrismicDocumentNavBarStyle =
  typeof styles;

export const constants = {
  logoHeight: 24,
  hideDesktopNavBarThreshold: 50,
  scrollTopThreshold: -100,
  showThreshold: 70,
  hideTopLinks: 400,
  hideTextLogo: 50,
};

//
export const animationProps = {
  pageTransition: {
    container: {},
  },
  firstLoad: {
    container: _.merge(_.cloneDeep(yTopFull), {
      variants: {
        show: {
          transition: { delay: 1 },
        },
      },
    }),
  },
  onScroll: {
    container: yTopFull,
  },
};

export type HyamPrismicDocumentNavBarAnimationProps =
  typeof animationProps;
